/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import { Observable, of } from 'rxjs';
import { switchMap, catchError, mergeMap } from 'rxjs/operators';
import { ofType, StateObservable } from 'redux-observable';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import { Action, ActionCreators } from './actions';
import { RootState } from '../index';
import { handleErrorInterceptor } from '../../utils/AuthUtils';
import { ActionCreators as TerminalsActions } from '../terminals/actions';
import { PortalsEnum } from '../../shared/entities/portal';

const requestTerminalHistorySuccess = (response: AjaxResponse<any>): any => {
  return ActionCreators.ReceivedTerminalHistorySuccess.create(response);
};

const setFlightPath = (response: AjaxResponse<any>, portal = PortalsEnum.UNIFIED_PORTAL): any => {
  if (response.response && response.response.flightPath) {
    return TerminalsActions.SetFlightPath.create({ flightPath: response.response.flightPath, portal });
  }
  return TerminalsActions.SetFlightPath.create({ flightPath: [], portal });
};

const createErrorAction = (error: AjaxError, defaultErrorMsg: string): any => {
  return ActionCreators.ReceivedTerminalHistoryError.create(
    error.message !== undefined ? error.message : defaultErrorMsg,
  );
};

const requestTerminalHistoryError = (error: AjaxError): any => {
  return createErrorAction(error, 'Error requesting terminal history');
};

export const getTerminalHistoryEpic = (
  action$: Observable<Action>,
  state$: StateObservable<RootState>,
  { ajaxRaw }: any,
): Observable<Action> =>
  action$.pipe(
    ofType(ActionCreators.RequestTerminalHistoryOnce.type),
    switchMap(($action: any): Observable<Action> => {
      let terminalHistorySuccessAction = mergeMap((response: AjaxResponse<any>): Action[] => [
        setFlightPath(response, $action.payload.portal),
        requestTerminalHistorySuccess(response),
      ]);

      return ajaxRaw.get(`/terminals/${$action.payload.datapathUuid}/history/all`).pipe(
        terminalHistorySuccessAction,
        catchError(
          (error: AjaxError): Observable<Action> =>
            handleErrorInterceptor(error, of(requestTerminalHistoryError(error))),
        ),
      );
    }),
  );
